export default __webpack_public_path__ + "static/media/RG_front.4d30b094.png";